// All design system shadows using within the Card App should be defined here.

import { styled } from '@withjoy/joykit';

// We still need to reconcile the names and values with those in the JoyKit Design System. They have drifted from JoyKit Figma.
export const BOX_SHADOW_8 = '0px 2.0457141399383545px 8.182856559753418px 0px rgba(0, 0, 0, 0.07), 0px 3.5799996852874756px 13.808570861816406px 0px rgba(44, 41, 37, 0.06)';
export const BOX_SHADOW_16 = '0px 4px 16px 0px rgba(0, 0, 0, 0.07), 0px 7px 27px 0px rgba(44, 41, 37, 0.06)';
export const BOX_SHADOW_60_02 = '0px 30px 60px -30px rgba(0, 0, 0, 0.2), 0px 50px 100px -20px rgba(44, 41, 37, 0.17)';
export const BOX_SHADOW_60_03 = '0px 30px 60px -30px rgba(0, 0, 0, 0.3), 0px 50px 100px -20px rgba(44, 41, 37, 0.25)';

export const BOX_SHADOW_8_14_26 = `
	  0px  2px  8px  0px hsla(35, 10%, 50%, 0.15),
	 -8px 12px 14px -8px hsla(35, 10%, 49%, 1.00),
	-14px 12px  8px -8px hsla(33, 13%, 58%, 0.20),
	-26px 20px 11px -5px hsla(33, 13%, 58%, 0.27)`;

export const GalleryShadow = styled.div`
  /* prettier-ignore */
  filter:
    drop-shadow(  0px  2px  8px hsla(35,  8%, 50%, 0.1))
    drop-shadow( -3px  6px 10px hsla(35,  8%, 50%, 0.5))
    drop-shadow(-14px  6px  2px hsla(33, 10%, 60%, 0.3))
    drop-shadow(-24px 20px  9px hsla(33, 10%, 60%, 0.3));
`;
